var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"inline-flex items-center gap-2 text-xs text-brand-red-14",attrs:{"data-component":"CsFormError"}},[_c(_setup.CsIcon,{staticClass:"flex-none",attrs:{"name":"alert-circle"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }